import React from "react";
import { withHidden } from "./util";
import { useField } from "formik";
import "./LabeledField.scss";
import { DatePickerField } from "./DatePicker";
import cx from "classnames";

export interface LabeledFieldBaseProperties {
  label: string | JSX.Element;
  type?: "textarea" | "date" | "text";
}

function LabeledFieldBase({
  label,
  type,
  className,
  inputClass,
  ...props
}: LabeledFieldBaseProperties & any) {
  const [field, meta] = useField(props);
  if (type === "checkbox") {
    return (
      <div className={cx("form-check", className)}>
        <label className="form-check-label">
          <input
            className={cx("form-check-input", inputClass)}
            type={type}
            checked={field.value} // fixes known issue with formik input checkboxes
            {...field}
            {...props}
          />
          <span>{label}</span>
        </label>
      </div>
    );
  }
  const clazz = cx("form-control", inputClass);
  return (
    <div className={cx("form-group", "labelField", className)}>
      <label>
        <div className="pb-2">{label}</div>
        {type === "textarea" ? (
          <textarea className={clazz} {...field} {...props} />
        ) : type === "date" ? (
          <DatePickerField className={clazz} type={type} {...field} {...props} />
        ) : (
          <input className={clazz} type={type} {...field} {...props} />
        )}
      </label>
      {meta.touched && meta.error ? <div className="error">{meta.error}</div> : null}
    </div>
  );
}

const LabeledField = withHidden(LabeledFieldBase);
export default LabeledField;
